import * as Yup from 'yup';
import {
  VALIDATION_ERROR_MESSAGE_KEY,
  VALIDATION_ZIPCODE_INVALID_KEY,
  VALIDATION_PHONE_INVALID_KEY,
} from '../constants';

const requiredField = Yup.string().required(VALIDATION_ERROR_MESSAGE_KEY);

export const REGISTRATION_VALIDATION_SCHEMA = Yup.object().shape({
  firstName: requiredField,
  lastName: requiredField,
  ownerEmail: requiredField,
  country: requiredField,
  phone: Yup.string()
    .required(VALIDATION_ERROR_MESSAGE_KEY)
    .matches(/^[0-9]+$/, VALIDATION_PHONE_INVALID_KEY),
  zipCode: Yup.string()
    .required(VALIDATION_ERROR_MESSAGE_KEY)
    .test(
      'zipcode-mx-min-length',
      VALIDATION_ZIPCODE_INVALID_KEY,
      function (value) {
        const { country } = this.parent;

        if (country.toUpperCase() === 'MX' && value && value.length < 5) {
          return false;
        }

        return true;
      },
    ),
  address: requiredField,
  state: requiredField,
  city: requiredField,
});
